import React from "react";
import {customerLogout} from "../../containers/Authentication/Auth/utils";
import {AuthResource} from "../../utils/api";
import {setInStorage} from "../../utils/storage";

const UnAuthorized = props => {
  const {
    location: {
      pathname
    },
    auth: {
      user
    }
  } = props;

  const getAgencyId = () => {
    // todo need to find better solution, for now all customer routes start from agency_id
    // return Object.keys(ROUTES.CUSTOMER).some(key => ROUTES.CUSTOMER[key].path === path)
    const agency_id = pathname.split('/')[1];
    return typeof +agency_id === 'number' && +agency_id > 0 ? agency_id : null;

  };

  if (!user) {
    const agency_id = getAgencyId();
    if (agency_id) {
      customerLogout(agency_id)
    } else {
      AuthResource.at('broker/broker_open_id/').get().then(res => {
        const loginUrl = res.login_url.replace('%3A8000', '%3A3000');
        const redirectUri = new URL(loginUrl).searchParams.get('redirect_uri');

        setInStorage('code_verifier', {code_verifier: res.code_verifier, redirectUri: redirectUri, backUrl: window.location.pathname + window.location.search});

        window.location.href = loginUrl;
      });

      return (
        <div style={{textAlign: 'center'}}>
          <h1>Willkommen bei DIVA</h1>
          <div style={{color: '#202a3880', fontSize: 17, marginTop: '.25rem'}}><b>Die Serviceplattform für Vermittler</b></div>
          <div style={{width: '4.6875rem', height: 1, background: 'currentColor', margin: '.9375rem auto 1.5625rem'}}></div>
        </div>
      )
    }
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center'
    }}>
      <h1>Bitte Login erneut durchführen</h1>
    </div>
  )
};

export default UnAuthorized;